import { motion } from "framer-motion";
import { ProductCard } from "@/components/ProductCard";
import { useSearch } from "@/context/SearchContext";

export const CategorySection = ({ id, index, label, title, description, products }) => {
  const { query } = useSearch();
  const q = query.trim().toLowerCase();
  const filtered = q
    ? products.filter((p) => `${p.name} ${p.substance} ${p.description}`.toLowerCase().includes(q))
    : products;

  if (q && filtered.length === 0) return null;

  return (
    <section id={id} className="py-24 md:py-32 px-6 md:px-12" data-testid={`category-${id}`}>
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-20"
        >
          <div className="max-w-2xl">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-grotesk italic text-2xl text-[#29FF87]">{index}</span>
              <span className="h-px w-16 bg-[#29FF87]" />
              <span className="font-body text-xs uppercase tracking-[0.4em] text-[#29FF87]">{label}</span>
            </div>
            <h2 className="font-grotesk font-light text-5xl md:text-7xl tracking-tighter leading-none">{title}</h2>
          </div>
          {description && <p className="max-w-sm font-body text-sm md:text-base text-zinc-400 leading-relaxed">{description}</p>}
        </motion.div>

        {filtered.length === 0 ? (
          <p className="font-body text-zinc-600 text-sm uppercase tracking-[0.2em]">No products in this category yet.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </section>
  );
};
